module.exports = __webpack_public_path__ + "static/media/costpic1@3x.63969300.png";